import PrescriptionRouting from "./prescription_routing";

export {PrescriptionRouting};